import { Capacitor, registerPlugin } from '@capacitor/core';

/** Native plugin in the app target: ios/App/App/AppleSignInPlugin.swift */
type AppleSignInPlugin = {
  authorize: () => Promise<{
    user: string;
    email: string | null;
    identityToken: string;
    authorizationCode: string | null;
  }>;
};

type AppleCredentials = {
  identityToken: string;
  authorizationCode?: string;
};

const AppleSignIn = registerPlugin<AppleSignInPlugin>('AppleSignIn');

const isAppleSignInAvailable = (): boolean => Capacitor.getPlatform() === 'ios';

/**
 * Shows the system "Sign in with Apple" sheet. Null when the player closed
 * it, so callers only report real failures.
 */
const authorizeWithApple = async (): Promise<AppleCredentials | null> => {
  try {
    const { identityToken, authorizationCode } = await AppleSignIn.authorize();

    return {
      identityToken,
      ...(authorizationCode ? { authorizationCode } : {}),
    };
  } catch (e) {
    if ((e as { code?: string }).code === 'CANCELED') return null;
    throw e;
  }
};

export { authorizeWithApple, isAppleSignInAvailable };
export type { AppleCredentials };
